import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;
import 'slick-carousel';
import axios from 'axios';
import handlesToTiles from '../utilities/handlesToTiles';

const theresEnoughSpace = (width, itemMinWidth, itemCount) => {
  console.log(width, itemMinWidth, itemCount, width / itemCount);
  return (width / itemCount) >= itemMinWidth;
}

const shouldBeSlicked = (width, slickOptions) => {
  const { responsive, mobileFirst } = slickOptions;

  let shouldSlick = true;

  if (responsive && responsive.length > 0) {
    const sortedBreakpoints = responsive.sort((a, b) => mobileFirst ? a.breakpoint - b.breakpoint : a.breakpoint + b.breakpoint);
    const currentBreakpoint = sortedBreakpoints.find(breakpoint => {
      return mobileFirst ? (width >= breakpoint.breakpoint) : (width <= breakpoint.breakpoint);
    });

    if (currentBreakpoint) {
      shouldSlick = currentBreakpoint.settings.unslick ? false : true;  
    }
  }

  return shouldSlick;
}

const populateCarousel = async (handlesArray, carousel) => {
  // Show before actually populating to show off our skeleton tiles.
  // To Do: Consider showing after to prevent case where population fails. Currently shows when population called.
  const wrapper = carousel.closest('.u_unpopulated');
  if (!wrapper) {
    return;
  }
  wrapper.classList.remove('u_unpopulated');

  const tiles = await handlesToTiles(handlesArray);
  const tilesMarkup = tiles.join('');
  carousel.innerHTML = tilesMarkup;

  // Add classes to allow graceful display
  // Reference: products_from_collection.liquid
  const addClasses = ['_less_than_two'];
  if (tiles.length > 2) {
    addClasses.length = 0;
    addClasses.push('_more_than_two');

    if (tiles.length > 3) {
      addClasses.push('_more_than_three');

      if (tiles.length > 4) {
        addClasses.push('_more_than_four');
      }
    }
  }
  carousel.classList.add(...addClasses);
}

const carouselise = async (el) => {

  const { handles } = el?.dataset;
  if (handles) {
    const handlesArr = handles.split(',');
    const handlesNotURLs = handlesArr.map(h => h.split('/').pop());
    await populateCarousel(handlesNotURLs, el);
  }

  const layout = el.dataset.layout || 'dynamic';

  // Check if the carousel has enough tiles to bother initialising, and don't do it if not.
  const tilesCount = el.querySelectorAll('.product-item').length;

  if (tilesCount <= 1) {
    return;
  }

  // Don't slick if using a non-Slick layout, such as show_5. 
  // Layouts are defined by us here and in the data-layout attribute, so it's up to you how many there are. 
  if (layout !== 'dynamic') {
    return;
  }

  const minTileWidth = 230;

  const slickOptions = {
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    mobileFirst: true,
    responsive: [    
      // Native slider for mobile
      {
        breakpoint: 1,
        settings: 'unslick',
      },
      {
        breakpoint: 768,
        settings: theresEnoughSpace(768, minTileWidth, tilesCount) ? 'unslick' : {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 1001,
        settings: theresEnoughSpace(1001, minTileWidth, tilesCount) ? 'unslick' : {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 1201,
        settings: theresEnoughSpace(1201, minTileWidth, tilesCount) ? 'unslick' : {
          slidesToShow: 5,
          slidesToScroll: 5,
        }
      },
      {
        breakpoint: 1401,
        settings: theresEnoughSpace(1401, minTileWidth, tilesCount) ? 'unslick' : {
          slidesToShow: 6,
          slidesToScroll: 6,
        }
      },
    ]
  };

  console.log(slickOptions);

  $(el).slick(slickOptions);

  window.addEventListener('resize', () => {
    const unslicked = $(el).slick('getSlick').unslicked;
    if (!unslicked) {
      console.log('its slicked, all g');
      return;
    }

    console.log(el.clientWidth);
    const containerWidth = el.clientWidth;

    if (shouldBeSlicked(containerWidth, slickOptions)) {
      $(el).slick(slickOptions);  
    }
  });
}

window.carouselise = carouselise;

const carousels = document.querySelectorAll('.collection_products_tiles');
Array.from(carousels).forEach(async c => {
  await carouselise(c);
});